import { Component, computed, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-toast',
    imports: [MatIcon],
    templateUrl: './toast.component.html',
    styleUrl: './toast.component.scss'
})
export class ToastComponent {
  /** The visual style of the toast */
  toastStyle = input<'information' | 'warning' | 'critical' | 'positive'>('information');

  /** The name of the icon to be displayed (optional) */
  icon = input<string>();

  /** The text to be displayed (required) */
  text = input<string>();

  /**
   * Computed property that generates the CSS classes for the toast
   * based on its current state and styling options
   */
  classes = computed(() => {
    return ['toast', this.toastStyle()];
  });
}
